import React from "react";

const Delete = () => {
  return (
    <div>
      <svg
        width="20"
        height="22"
        viewBox="0 0 20 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 4.98633H3M3 4.98633H19M3 4.98633V18.9863C3 19.5168 3.21071 20.0255 3.58579 20.4005C3.96086 20.7756 4.46957 20.9863 5 20.9863H15C15.5304 20.9863 16.0391 20.7756 16.4142 20.4005C16.7893 20.0255 17 19.5168 17 18.9863V4.98633M6 4.98633V2.98633C6 2.4559 6.21071 1.94719 6.58579 1.57211C6.96086 1.19704 7.46957 0.986328 8 0.986328H12C12.5304 0.986328 13.0391 1.19704 13.4142 1.57211C13.7893 1.94719 14 2.4559 14 2.98633V4.98633M8 9.98633V15.9863M12 9.98633V15.9863"
          stroke="#1E1E1E"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export default Delete;
